import type { FlattenedHivesResponse } from '@/features/HivesOverview/util'

const CSV_HEADERS = [
  'Status',
  'Org ID',
  'Cluster ID',
  'Cluster Name',
  'Company Name',
  'Plan',
  'Apiary',
] as const

export function escapeCsvField(value: string | undefined): string {
  const str = value ?? ''
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

export function buildHivesCsv(hives: FlattenedHivesResponse): string {
  const rows = hives.map((hive) =>
    [
      hive.hive_status,
      hive.org_id,
      hive.cluster_id,
      hive.cluster_name,
      hive.company_name,
      hive.plan,
      hive.apiary,
    ]
      .map(escapeCsvField)
      .join(','),
  )

  return [CSV_HEADERS.join(','), ...rows].join('\n')
}

export function exportHivesToCsv(hives: FlattenedHivesResponse) {
  const csv = buildHivesCsv(hives)

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  const date = new Date().toISOString().split('T')[0]

  link.href = url
  link.download = `hives-export-${date}.csv`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
